/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import RejectReasonModal from "../../Modals/rejectReason";
import IosSwitch from "../../components/iosSwitch";
import SearchBar from "../../components/SearchBar";
import FilterMenu from "../../components/filterMenu";
import GenerateLink from "../../Modals/generateLink";
import AddtoGroup from "../../Modals/addtogroup";
import Membership from "../../Modals/membership";
import EditText from "../../components/editText";
import StarIcon from "@mui/icons-material/Star";
import EditIcon from "@mui/icons-material/Edit";

const radioOptions = [
  {
    value: "year",
    label: (
      <div className="purchase_sub_bx">
        <p className="price">
          <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
          <ins>AED 8,000/</ins>
          <sub>Per year</sub>
        </p>
        <p>Ideal for those seeking uninterrupted, year-round access.</p>
      </div>
    ),
  },
  // {
  //   value: "quarter",
  //   label: (
  //     <div className="purchase_sub_bx">
  //       <p className="price">
  //         <img src="/static/images/subscription_icon.svg" alt="icon" />{" "}
  //         <ins>AED 4,500/</ins>
  //         <sub>Semi-annual</sub>
  //       </p>
  //       <p>A flexible option to access full membership benefits.</p>
  //     </div>
  //   ),
  // },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface CutomerBookingTableProps {
  isPast?: boolean;
}
const ManageCustomerDetail = ({ isPast }: CutomerBookingTableProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { status, memberType } = location.state || {};
  const [legal3, setLegal3] = useState<string>("");

  const rows = [
    {
      id: 1,
      name: "Amit Sharma",
      email: "amit.sharma@example.com",
      image: "/static/images/user_placeholder.png", // Replace with your actual image path
      type: "Paid",
      date: "12-06-2025",
    },
    {
      id: 2,
      name: "Priya Mehta",
      email: "priya.mehta@example.com",
      image: "/static/images/user_placeholder.png",
      type: "Complimentary",
      date: "12-06-2025",
    },
    {
      id: 3,
      name: "Rahul Verma",
      email: "rahul.verma@example.com",
      image: "/static/images/user_placeholder.png",
      type: "Free",
      date: "12-06-2025",
    },
  ];
  const transactions = [
    {
      id: "TXN12345",
      membershipStatus: "Solo",
      amount: 99.99,
      status: "Paid",
      date: "10 July 2025",
    },
    {
      id: "TXN12346",
      membershipStatus: "Primary",
      amount: 49.99,
      status: "Paid",
      date: "05 July 2025",
    },
    {
      id: "TXN12347",
      membershipStatus: "Split",
      amount: 29.99,
      status: "Pending",
      date: "01 July 2025",
    },
  ];

  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const goBack = () => {
    navigate(-1);
  };

  const [openModal2, setOpenModal2] = React.useState(false);
  const [openModal3, setOpenModal3] = React.useState(false);
  const [openModal4, setOpenModal4] = React.useState(false);
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);

  const rows1 = [
    {
      id: 1,

      bookingId: "#101",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      Category: "Dining",
      Status: "New",
      date: "22-06-2025",
      Name: "Abdullah",
    },
    {
      id: 2,

      bookingId: "#102",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      Category: "Experience",
      Status: "New",
      date: "22-06-2025",

      Name: "Abdullah",
    },
    {
      id: 3,

      bookingId: "#103",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      Category: "Event",
      Status: "New",
      date: "22-06-2025",

      Name: "Abdullah",
    },
    {
      id: 4,

      bookingId: "#104",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      Category: "Dining",
      Status: "New",
      date: "22-06-2025",

      Name: "Abdullah",
    },
    {
      id: 5,

      bookingId: "#105",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      Category: "Dining",
      Status: "New",
      date: "22-06-2025",

      Name: "Abdullah",
    },
  ];

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };

  const [Employee, setEmployee] = React.useState("0");
  const handleChange1 = (event: SelectChangeEvent) => {
    setEmployee(event.target.value as string);
  };
  const [Status, setStatus] = React.useState("0");
  const handleChange2 = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [assignToMe, setAssignToMe] = useState(true);
  const [assignToEmployee, setAssignToEmployee] = useState(false);
  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            Member Profile
          </h1>
        </div>

        <div className="profile_bx mt_40 mb_30">
          <div className="profile_dtl">
            <figure>
              <img src="/static/images/profile_img.png" alt="profile img" />
            </figure>
            <div className="profile_cnt">
              <h2 className="d_flx">
                Abdul Kean <StarIcon />
              </h2>
              <p>
                {" "}
                <a>
                  {" "}
                  <IconButton>
                    <img src="/static/images/email_icon.svg" alt="icon" />
                  </IconButton>{" "}
                  abdul@sample.com
                </a>
              </p>
              <p>
                {" "}
                <a>
                  {" "}
                  <IconButton>
                    <img src="/static/images/call_icon.svg" alt="icon" />
                  </IconButton>{" "}
                  +971 (0) 567894623
                </a>
              </p>
            </div>
          </div>
          <div
            className="rt"
            style={{ flexWrap: "wrap", justifyContent: "end" }}
          >
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal3(true)}
            >
              {" "}
              Add to Group
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() => navigate("/manage-customers/add")}
            >
              {" "}
              <img src="/static/images/edit_icon.svg" alt="icon" /> Edit Details
            </Button>
            <Button
              className="btn btn_grey"
              onClick={() => setOpenModal2(true)}
            >
              {" "}
              Generate Link
            </Button>
            <p
              style={{
                width: "80%",
                textAlign: "right",
                fontSize: "16px",
                color: "#fff",
              }}
            >
              Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sequi
              rerum mollitia porro? A voluptatibus molestias suscipit dolorem
              vel ullam ipsum. <EditIcon />{" "}
            </p>
          </div>
        </div>

        <div className="table_header">
          <div className="left_s">
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
              <Tabs
                value={valueTabs}
                onChange={handleChangeTabs}
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab label="Personal Info" {...a11yProps(0)} />
                <Tab label="Booking History" {...a11yProps(1)} />
              </Tabs>
            </Box>
          </div>
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="right_s">
              <SearchBar searchTerm={""} placeholder={"Search"} />
              <FilterMenu />
            </div>
          </CustomTabPanel>
        </div>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Personal Details</h2>
              <div className="btn_flex">
                {status === "PENDING" && (
                  <>
                    <Button className="btn btn_primary">Approve</Button>
                    <Button className="btn btn_primary br">Reject</Button>
                  </>
                )}
                {status === "APPROVED" && (
                  <>
                    <IosSwitch />
                    <Button className="btn btn_primary">Approved</Button>
                  </>
                )}
                {status === "REJECTED" && (
                  <Button className="btn btn_danger">Rejected</Button>
                )}
                {status === "EXPIRED" && (
                  <Button className="btn btn_grey">Expired</Button>
                )}
              </div>
            </div>
            <div className="section_sub_title mb_30">
              {memberType === "Duo" ? (
                <>
                  <figure>
                    <img alt="user" src="/static/images/duo_icon.svg" />
                  </figure>{" "}
                  <h3>Duo Membership</h3>
                </>
              ) : (
                <>
                  <figure>
                    <img alt="user" src="/static/images/single_member.svg" />
                  </figure>{" "}
                  <h3>Single Membership</h3>
                </>
              )}
              <span className="tag">Trial</span>
            </div>
            {memberType === "Duo" ? (
              <>
                <div className="gap_p ">
                  <div className="w_25">
                    <h6>Type</h6>
                    <p>Paid</p>
                  </div>
                  <div className="w_25">
                    <h6>Payment Method:</h6>
                    <p>Monthly</p>
                  </div>
                  <div className="w_25">
                    <h6>Created Date</h6>
                    <p>18 - June - 2025</p>
                  </div>
                  <div className="w_25">
                    <h6>Expire Date</h6>
                    <p>18 - June - 2025</p>
                  </div>
                  <div className="w_25">
                    <h6>Next Payment</h6>
                    <p>20 - July - 2025</p>
                  </div>
                  <div className="w_25">
                    <h6>Referral Code</h6>
                    <p>XYZ635</p>
                  </div>
                  <div className="w_25">
                    <h6>Is Referred?</h6>
                    <p>Yes by John Mate</p>
                  </div>
                  <div className="w_25">
                    <h6>Payment Preference</h6>
                    <p>Split</p>
                  </div>
                  <div className="w_25">
                    <h6>Partner Code</h6>
                    <p>786FYUI</p>
                  </div>
                  <div className="w_25">
                    <h6>Last Login Date & Time</h6>
                    <p>22-06-2025 ,12:00 PM</p>
                  </div>
                </div>
                <div className="control_group">
                  <hr />
                </div>
                <div className="section_title mb_20">
                  <h2>Partner Detail</h2>
                </div>
                <div className="gap_p view_page">
                  <div className="control_group w_25">
                    <h6>Name</h6>
                    <p className="text_btn">Catherine Bell</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Email</h6>
                    <p>catherinebell@gmail.com</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Phone Number</h6>
                    <p>+971 (0) 567894623</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Next Payment</h6>
                    <p>Vegan, Lactose Intolerant</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Birthday</h6>
                    <p>20 July, 2000</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Gender</h6>
                    <p>Female</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Address</h6>
                    <p>AI Markup street villa 35</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Field Of Expertise</h6>
                    <p>Sports & Recreation</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Dietary Requirements*</h6>
                    <p>Travel & Dining</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Interests</h6>
                    <p>Events, Travel, Night life</p>
                  </div>
                </div>
                <div className="control_group">
                  <hr />
                </div>
                <div className="section_title mb_20">
                  <h2>Payment Status</h2>
                </div>
                <div className="gap_p view_page">
                  <div className="control_group w_25">
                    <h6>Primary</h6>
                    <p>Paid</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Secondary</h6>
                    <p>Pending</p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="gap_p ">
                  <div className="w_25">
                    <h6>Type</h6>
                    <p>Paid</p>
                  </div>
                  <div className="w_25">
                    <h6>Payment Method:</h6>
                    <p>Monthly</p>
                  </div>
                  <div className="w_25">
                    <h6>Created Date</h6>
                    <p>18 - June - 2025</p>
                  </div>
                  {status !== "EXPIRED" && (
                    <div className="w_25">
                      <h6>Next Payment</h6>
                      <p>20 - July - 2025</p>
                    </div>
                  )}
                  {status === "EXPIRED" && (
                    <div className="w_25">
                      <h6>Expire Date</h6>
                      <p>20 - July - 2025</p>
                    </div>
                  )}
                  <div className="w_25">
                    <h6>Birthday</h6>
                    <p>20 July, 2000</p>
                  </div>
                  <div className="w_25">
                    <h6>Gender</h6>
                    <p>Female</p>
                  </div>
                  <div className="w_25">
                    <h6>Address</h6>
                    <p>AI Markup street villa 35</p>
                  </div>
                  <div className="w_25">
                    <h6>Field Of Expertise</h6>
                    <p>Sports & Recreation</p>
                  </div>
                  <div className="w_25">
                    <h6>Dietary Requirements*</h6>
                    <p>Travel & Dining</p>
                  </div>
                  <div className="w_25">
                    <h6>Interests</h6>
                    <p>Events, Travel, Night life.cards</p>
                  </div>
                  <div className="w_25">
                    <h6>Referral Code</h6>
                    <p>XYZ635</p>
                  </div>
                  <div className="w_25">
                    <h6>Is Referred?</h6>
                    <p>Yes by John Mate</p>
                  </div>
                  <div className="w_25">
                    <h6>Last Login Date & Time</h6>
                    <p>22-06-2025 ,12:00 PM</p>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Membership Plan</h2>
            </div>
            {memberType === "Duo" ? (
              <>
                <div className=" plan_grid">
                  <h3>Paid</h3>
                </div>
                <div className="btn_flex flx_end">
                  <Button className="btn btn_primary">
                    Cancel Subscription
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className=" plan_grid">
                  <h3>Free</h3>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="year"
                    name="radio-buttons-group"
                    className="v2 mt_20"
                  >
                    {radioOptions.map((option) => (
                      <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                      />
                    ))}
                  </RadioGroup>
                </div>
                <div className="btn_flex flx_end">
                  <p>Request to upgrade has been sent</p>
                  <Button
                    className="btn btn_primary"
                    onClick={() => setOpenModal4(true)}
                  >
                    Upgrade Plan
                  </Button>
                </div>
              </>
            )}
          </div>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Referral History</h2>
              <div className="btn_flex">
                <SearchBar searchTerm={""} placeholder={"Search"} />
              </div>
            </div>
            <div className="table_container">
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>User Image</th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Date</th>
                    <th>Type</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.id}>
                      <td>
                        <img
                          src={row.image} // You can replace this value in your data
                          alt={row.name}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                      </td>
                      <td>{row.name}</td>
                      <td>{row.email}</td>
                      <td>{row.date}</td>
                      <td>{row.type}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="cards view_page">
            <div className="section_title">
              <h2>Transaction History</h2>
              <div className="btn_flex">
                <SearchBar searchTerm={""} placeholder={"Search"} />
              </div>
            </div>
            <div className="table_container">
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#C19857",
                      color: "#fff",
                      textAlign: "left",
                    }}
                  >
                    <th>Transaction ID</th>
                    <th>Membership Status</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((txn) => (
                    <tr
                      key={txn.id}
                      style={{ borderBottom: "1px solid #444", color: "#fff" }}
                    >
                      <td>{txn.id}</td>
                      <td>{txn.membershipStatus}</td>
                      <td>AED{txn.amount.toFixed(2)}</td>
                      <td
                        style={{
                          color: txn.status === "Paid" ? "green" : "orange",
                        }}
                      >
                        {txn.status}
                      </td>
                      <td>{txn.date}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>Booking ID</th>

                  <th>Booking Time</th>
                  <th>Guests</th>
                  <th>Category</th>
                  <th>Internal Status</th>
                  <th>Date Created</th>
                  <th>Employee Name</th>
                </tr>
              </thead>
              <tbody>
                {rows1.map((row) => (
                  <React.Fragment key={row.id}>
                    <tr>
                      <td>{row.bookingId}</td>
                      <td>
                        <p
                          className="text_btn cursor_p"
                          onClick={() => toggleExpand(row.id)}
                        >
                          {row.BookingTime}
                        </p>
                      </td>
                      <td>{row.Guests}</td>
                      <td>{row.Category}</td>
                      <td>{row.Status}</td>
                      <td>{row.date}</td>
                      <td>{row.Name}</td>
                    </tr>

                    {expandedRowId === row.id && (
                      <tr>
                        <td colSpan={8}>
                          <div className="expanded-content">
                            <div className="form_flex">
                              <div className="w_100">
                                <div className="control_group mb_0 employee_list">
                                  <Select
                                    value={Employee}
                                    onChange={(e: SelectChangeEvent) =>
                                      setEmployee(e.target.value)
                                    }
                                  >
                                    <MenuItem value="0" disabled>
                                      Employee Listing
                                    </MenuItem>
                                    <MenuItem value="10">Adam Smith</MenuItem>
                                    <MenuItem value="20">Denny Juan</MenuItem>
                                    <MenuItem value="30">Hermanto</MenuItem>
                                  </Select>
                                </div>

                                <Select
                                  value={Status}
                                  onChange={(e: SelectChangeEvent) =>
                                    setStatus(e.target.value)
                                  }
                                  className="booking_status"
                                >
                                  <MenuItem value="0" disabled>
                                    Status
                                  </MenuItem>
                                  <MenuItem value="10">New</MenuItem>
                                  <MenuItem value="20">In Progress</MenuItem>
                                  <MenuItem value="30">Pending Venue</MenuItem>
                                  <MenuItem value="40">Pending Member</MenuItem>
                                  <MenuItem value="50">Confirmed</MenuItem>
                                  <MenuItem value="60">Cancelled</MenuItem>
                                </Select>

                                <div className="control_group add_note">
                                  <TextField
                                    placeholder="Add Notes"
                                    hiddenLabel
                                    fullWidth
                                  />
                                </div>

                                <Button className="btn btn_primary">
                                  Save
                                </Button>
                              </div>

                              <div className="w_100">
                                <Checkbox /> Assign to me
                              </div>

                              {row.Category === "Experience" && (
                                <>
                                  <div
                                    className="w_100"
                                    style={{ alignItems: "flex-start" }}
                                  >
                                    <div className="control_group w_50">
                                      <TextField
                                        placeholder="Amount"
                                        hiddenLabel
                                        fullWidth
                                      />
                                    </div>
                                    <div className="control_group w_50">
                                      <div className="control_group w_100">
                                        <EditText
                                          content={legal3}
                                          setContent={setLegal3}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </CustomTabPanel>
      </MainContainer>

      <RejectReasonModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />

      <GenerateLink
        open={openModal2}
        onClose={() => setOpenModal2(false)}
        setOpen={setOpenModal2}
        type="userManagement"
      />
      <AddtoGroup
        open={openModal3}
        onClose={() => setOpenModal3(false)}
        setOpen={setOpenModal3}
      />
      <Membership
        open={openModal4}
        onClose={() => setOpenModal4(false)}
        setOpen={setOpenModal4}
      />
    </>
  );
};

export default ManageCustomerDetail;
